// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6801":"bc585617","7407":"fff0bccc"}[chunkId] + ".chunk.css";
};